import React from "react";
import { UiCardTitle } from "../../../components/common/UiCardTitle";
import { UiContentCol, UiContentWr } from "../../../components/common/UiPageElements";
import { UiCol, UiRowContainer } from "../../../components/grid-container/GridContainer";
import balTransImg1 from "../../../../../styles/img/balTransImg1.png"
import balTransImg2 from "../../../../../styles/img/balTransImg2.png"

export const BalanceTransactions = () => {
    return (
        <>
            <UiContentWr>
                <UiRowContainer fluid="fluid" className="sb-bal-trans">
                    <UiCol lg="6">
                        <UiCardTitle title="Balance & Transactions" />

                        <div className="sb-bal-trans__bal-info">
                            <div className="sb-bal-title">
                                <h5>Balance at</h5>
                            </div>
                            <div className="sb-bal-desc">
                                <p>Monday 23rd January 2023 </p>
                            </div>
                        </div>

                        <div className="sb-bal-trans__bal-info">
                            <div className="sb-bal-title">
                                <h5>Balance with Pending</h5>
                            </div>
                            <div className="sb-bal-desc">
                                <p>65,764 Points</p>
                            </div>
                        </div>

                        <div className="sb-bal-trans__bal-info">
                            <div className="sb-bal-title">
                                <h5>Available Balance</h5>
                            </div>
                            <div className="sb-bal-desc">
                                <p className="total-points">65,764 Points</p>
                            </div>
                        </div>

                    </UiCol>

                    <UiCol lg="6">
                        <UiContentCol>
                            <div className="sb-bal-trans__img-col">
                                <div className="sb-dark-overl-card">
                                    <img src={balTransImg1} />
                                </div>
                            </div>

                            <div className="sb-bal-trans__img-col">
                                <div className="sb-dark-overl-card">
                                    <div className="sb-dark-overl-card__overl" />
                                    <h4>Shopify <br /> Advert</h4>
                                    <img src={balTransImg2} />
                                </div>
                            </div>
                        </UiContentCol>
                    </UiCol>

                </UiRowContainer>
            </UiContentWr>
        </>
    )
}